import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import { IActionsHeaderKpi } from '@base/@types/providers/Kpi/SalesProvider'

export const actionsHeaderKpi = ({
  data,
  headers,
  toggleColumn,
  parseSalesKpiData
}: IActionsHeaderKpi) => {
  return [
    {
      type: 'export',
      exports: [
        {
          type: 'excel',
          entity: 'salesKpi',
          data,
          headers,
          parser: parseSalesKpiData
        }
      ]
    },
    {
      type: 'columns',
      data: headers,
      onToggleColumn: toggleColumn
    }
  ] as ILayoutToolsAction[]
}
